angular
  .module('users.module', [
    'ui.router'
  ]);
